import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Loader from '../../loader/Loader';
import './Button.scss';

export const BUTTON_KIND_BRAND = 'brand';
export const BUTTON_KIND_ACTION = 'action';
export const BUTTON_KIND_BRAND_HOVER = 'brand-hover';
export const BUTTON_KIND_TRANSPARENT = 'transparent';
export const BUTTON_KIND_TRANSPARENT_REVERSED = 'transparent-reversed';
export const BUTTON_KIND_CANCEL = 'cancel';
export const BUTTON_KIND_WHITE = 'white';
export const BUTTON_KIND_LABEL_ONLY = 'label-only';

const Button = ({
	kind,
	children,
	icon,
	small,
	large,
	roundSmall,
	roundMedium,
	roundLarge,
	roundHuge,
	fullWidth,
	disabled,
	backgroundColor,
	href,
	to,
	loading,
	...props
}) => {
	const BaseElement = to ? Link : href ? 'a' : 'button';

	return (
		<BaseElement
			className={classNames(`button button--${kind}`, {
				'button--large': large,
				'button--small': small,
				'button--disabled': disabled,
				'button--round--small': roundSmall,
				'button--round--medium': roundMedium,
				'button--round--large': roundLarge,
				'button--round--huge': roundHuge,
				'button--loading': loading,
				'button--full-width': fullWidth,
				[backgroundColor]: backgroundColor,
			})}
			to={to}
			href={href}
			role={!to && !href ? 'button' : null}
			disabled={disabled}
			{...props}
		>
			{icon && <i className={`icon ${icon}`} />}
			{loading && <Loader />}
			<span className="button__text">{children}</span>
		</BaseElement>
	);
};

Button.propTypes = {
	kind: PropTypes.oneOf([
		BUTTON_KIND_BRAND,
		BUTTON_KIND_BRAND_HOVER,
		BUTTON_KIND_ACTION,
		BUTTON_KIND_TRANSPARENT,
		BUTTON_KIND_TRANSPARENT_REVERSED,
		BUTTON_KIND_CANCEL,
		BUTTON_KIND_WHITE,
		BUTTON_KIND_LABEL_ONLY,
	]),
	href: PropTypes.string,
	icon: PropTypes.string,
	children: PropTypes.node.isRequired,
	roundSmall: PropTypes.bool,
	roundMedium: PropTypes.bool,
	roundLarge: PropTypes.bool,
	roundHuge: PropTypes.bool,
	small: PropTypes.bool,
	disabled: PropTypes.bool,
	backgroundColor: PropTypes.string,
	loading: PropTypes.bool,
};

Button.defaultProps = {
	kind: BUTTON_KIND_TRANSPARENT,
};

export default Button;
